<template>
  <section class="main-notice-detail-ko-section">
    <div class="title">유심사 계정 통합 및 본인확인 도입 안내</div>
    <div class="main-section">
      <div>
        <p>
          안녕하세요. 900만의 여행 필수품, 유심사입니다. <br />그동안 유심사를 이용해 주신 모든
          고객님께 진심으로 감사드립니다.
        </p>

        <p>
          더욱 안전하고 편리한 서비스를 제공하기 위해, 다가오는
          <span class="focus-text">2026년 5월 6일 (수) 오후 2시</span>
          부터 ‘계정 통합’ 개편이 진행될 예정이었으나,
          <span class="focus-text"> 서비스 안정화를 위해 2026년 5월 8일로 변경하였습니다. </span>
          <br />
          <span class="list-of">
            서비스 적용일 변경 : 5월 6일 -> <span class="focus-text">5월 8일</span>
          </span>
        </p>
        <p>
          이번 개편을 통해 보안이 강화된
          <span class="focus-text">‘국내 통신사 휴대폰 본인 확인’</span>이 필수적으로 도입됩니다.
          이에 따라
          <span class="yellow-text">
            본인 확인이 어려우신 고객님들께서는 개편 이후 기존 유심사 서비스 로그인이 제한될 예정
          </span>
          입니다.
        </p>
        <p>
          서비스 이용에 불편을 드리게 된 점 너른 양해 부탁드립니다. 아래 안내를 꼭 확인해 주세요.
        </p>
      </div>
      <div class="hr-section"></div>
      <div class="auth-possible-section">
        <h4 class="auth-possible-title">
          ✅ 본인 확인이 가능한 고객님 (국내 통신사 본인 확인 가능)
        </h4>
        <ul class="mt-default">
          <li>SKT, KT, LGU+ 및 알뜰폰 가입자</li>
          <li>
            기존처럼 모든 서비스를 <span class="focus-text">정상적으로 이용하실 수 있습니다.</span>
          </li>
          <li>5월 8일 이후 최초 1회 본인확인을 통해 계정 통합을 진행해 주시면 됩니다.</li>
        </ul>
        <div class="coupon-service-notice-wrap">
          <div>
            <p class="coupon-service-txt-bold">
              서비스 보안 강화 및 계정 통합에 따른 쿠폰 정책 변경 안내(계정통합 고객님들께 해당)
            </p>
            <p class="coupon-service-txt">26년 5월 13일 업데이트</p>
          </div>

          <button
            class="view-more-coupon-notice"
            @click="handleGoViewMoreNotice"
          >
            자세한 내용 확인하기
          </button>
        </div>
      </div>
      <div class="hr-section"></div>
      <div class="auth-impossible-section">
        <h4 class="auth-impossible-title">⚠️ 본인 확인이 어려운 고객님을 위한 필수 안내</h4>
        <div class="auth-impossible-range mt-default">
          <h5>💡 대상 범위</h5>
          <ul>
            <li>해외 현지 통신사 번호만 보유하신 경우(국내 통신사 X)</li>
            <li>가족 등 타인 명의의 휴대폰을 사용 중인 경우</li>
            <li>본인확인 서비스가 지원되지 않는 일부 선불폰/법인폰 사용 경우</li>
          </ul>
        </div>
        <div class="auth-impossible-des mt-default">
          <ul>
            <li>
              구매 내역 확인 및 CS 지원
              <p>
                안심하세요. 개편 이후 기존 구매 내역 확인, 로그인 불가, 그외 불편 사항이 있으신 경우
                24시간 운영중인 고객센터로 언제든 연락해 주시면 신속하게 도움을 드리겠습니다
              </p>
            </li>
            <li>
              미사용 eSIM QR코드 저장
              <p>
                미리 구매 후 아직 사용하지 않은 eSIM이 있다면, 개편 이후 사용이 어려울 수 있습니다.
                원활한 사용을 위해 미리 QR코드를 발급받아 스마트폰에 캡처(저장)해 두세요.
              </p>
            </li>
            <li>
              쿠폰 및 적립금 안내
              <p>
                보유하고 계신 쿠폰과 적립금은 로그인이 제한됨에 따라 개편(5/8) 이후에는 사용이
                어렵습니다. 가급적 개편일 이전에 사용해 주시기를 부탁드립니다.
              </p>
            </li>
            <li>
              유심사에서 '비회원'으로 계속 이용
              <p>
                로그인이 불가하더라도 기존처럼 유심사를 계속 이용하고 싶으시다면, 상품 결제 시
                <span class="focus-text">'비회원 구매'</span>를 선택해 주세요. 별도의 본인확인 절차
                없이 간편하게 eSIM을 구매하고 QR코드를 받아보실 수 있습니다. (단, 비회원 결제 시
                기존 쿠폰/적립금 사용은 불가합니다.)
              </p>
            </li>
            <li>
              유심사 글로벌 전용 서비스 ‘슈페라링크(Superalink)’ 이용
              <p>
                글로벌 전용 서비스인 '슈페라링크(Superalink)'를 이용하시면, 외국인 고객님들도
                회원가입 후 편리하게 다양한 혜택과 상품을 만나보실 수 있습니다.
                슈페라링크(Superalink) 관련하여 궁금하신 점은 언제든 고객센터로 문의해 주시기
                바랍니다.
              </p>
            </li>
          </ul>
          <p
            class="route-supera"
            @click="emits('moveToSupera')"
          >
            👉 <span class="route-supera-focus">슈페라링크(Superalink) 바로가기</span>
          </p>
        </div>
      </div>
      <div class="hr-section"></div>
      <div class="last-info-section">
        <p>앞으로도 더 나은 서비스를 위해 최선을 다하는 유심사가 되겠습니다.</p>
        <p>감사합니다.</p>
        <h4
          class="channel-home"
          @click="emits('moveToChannelHome')"
        >
          유심사 고객센터 바로가기
        </h4>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const emits = defineEmits<{
  moveToSupera: []
  moveToChannelHome: []
}>()

const handleGoViewMoreNotice = () => {
  window.open('https://www.usimsa.com/board/notice/BBC68B3F-814E-F111-8EF3-6045BD475294', '_blank')
}
</script>

<style scoped lang="scss">
.coupon-service-notice-wrap {
  padding: 12px;
  background-color: $usdg-color-gray-050;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 30px 0;
  border-radius: 12px;
}

.view-more-coupon-notice {
  color: #0066ff;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 700;
  line-height: 32px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  border: none;
  background-color: transparent;
  margin-right: auto;
  padding: 0;
}

.coupon-service-txt,
.coupon-service-txt-bold {
  color: $usdg-color-gray-800;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  line-height: 32px;
  margin-top: 0 !important;
}

.coupon-service-txt {
  font-weight: 400;
}

.coupon-service-txt-bold {
  font-weight: 700;
}
.main-notice-detail-ko-section {
  padding: 56px 20px 16px;
  .focus-text {
    font-weight: 700;
  }
  .list-of {
    &::before {
      content: '• ';
    }
  }

  .yellow-text {
    font-weight: 700;
    color: #ff9a12;
  }
  p + p {
    margin-top: 32px;
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    line-height: 26px;
  }
  .main-section {
    margin-top: 8px;
    padding: 8px 4px 20px;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    color: #424242;
  }
  .hr-section {
    margin: 30px 0;
    height: 1px;
    border-bottom: 1px solid #eeeeee;
  }
  .auth-possible-section {
    .auth-possible-title {
      color: #424242;
      font-size: 18px;
      font-weight: 700;
      line-height: 26px;
    }
  }
  .auth-impossible-section {
    font-size: 16px;
    .auth-impossible-title {
      color: #ff9a12;
      font-size: 18px;
      font-weight: 700;
      line-height: 26px;
    }
    .auth-impossible-range {
      padding: 12px;
      background-color: #f9f9f9;
      border-radius: 12px;
      line-height: 32px;
      h5 {
        font-weight: 700;
      }
      li {
        font-weight: 400;
      }
    }
    .auth-impossible-des {
      ul {
        li {
          font-weight: 700;
          p {
            font-weight: 400;
          }
        }
      }
      .route-supera {
        margin-top: 32px;
        font-size: 16px;
        font-weight: 700;
        line-height: 45px;
        cursor: pointer;
        .route-supera-focus {
          text-decoration-line: underline;
          text-decoration-style: solid;
          text-decoration-skip-ink: auto;
          text-decoration-thickness: auto;
          text-underline-offset: auto;
          text-underline-position: from-font;
        }
      }
    }
  }
  .last-info-section {
    .channel-home {
      cursor: pointer;
      margin-top: 30px;
      font-weight: 700;
      line-height: 24px; /* 150% */
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
    }
  }
}
</style>
